import React, {useEffect} from 'react';
import { Box, Flex, Heading, Progress, Text, VStack, Icon, Spinner } from '@chakra-ui/react';
import { FaRobot, FaCheck } from 'react-icons/fa';
import { useNavigate } from "react-router";
import { useStore } from "../../Store";
import webSocketStore from "../../Store/webSocketStore";
import { useBreadcrumbs } from "../../contexts/BreadcrumbProvider"
import "./CreateAIContentLoader.scss"

export const CreateAIContentLoader = () => {
  const {book, course, resetStatesBook, resetStatesCourse} = useStore((state) => state);

  const { addMultiBreadCrumb } = useBreadcrumbs();
  const navigate = useNavigate();
  const uploadStatuses = webSocketStore((state) => state.uploadStatuses);
  const product = window.location.href.includes("book") ? book : course
  const progress = uploadStatuses[product?.uuid]?.progress
  console.log({progress})
  const steps = [
    {
      id: 1,
      name: "Reading the outline",
      percentageToComplete: 5
    },
    {
      id: 2,
      name: "Analyzing outline requirements",
      percentageToComplete: 15
    },
    {
      id: 3,
      name: "Generating modules",
      percentageToComplete: 30
    },
    {
      id: 4,
      name: "Creating learning materials for each module",
      percentageToComplete: 75
    },
    {
      id: 5,
      name: "Finalizing content",
      percentageToComplete: 100
    },
  ]

  useEffect(() => {
    if(uploadStatuses[product?.id]?.progress === 100) {
      if(window.location.href.includes("book")) {
            resetStatesBook()
        } else {
            resetStatesCourse()
        }
      addMultiBreadCrumb([{ label: "Home", path: "/" }, { label: "Catalog", path: "/catalogs" }, { label: product?.catalogName, path: `/catalog/${product?.id}` }, { label: product?.name, path: "" }])
      navigate(`/content/${product?.id}`);
    }
  }, [uploadStatuses[product?.id]?.progress])

  return (
    <Flex align="center" justify="center" p={4}>
      <Box w="full" maxW="2xl" bg="white" rounded="lg" shadow="lg" p={8}>
        <VStack spacing={4} textAlign="center" mb={8}>
          <Heading as='h3' size='lg'>Processing Your Content</Heading>
          <Text fontSize="md">Our AI agent is generating your course</Text>
        </VStack>

        <Flex justify="center" mb={8} position="relative">
          <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.500'
            width="100px"
            height="100px"
          />
          <Icon as={FaRobot} fontSize="3xl" color="blue.500" position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" />
        </Flex>

        <Box mb={8}>
          <Progress value={progress} size="sm" colorScheme="blue" mb={2} />
          <Flex justify="space-between" fontSize="sm" color="gray.600">
            <Text>Estimated time: 5-10 minutes</Text>
            <Text>{progress ? progress : 0}% Complete</Text>
          </Flex>
        </Box>

        <VStack spacing={4} align="stretch" mb={8}>
          {steps.map((step, index) => {
            return (
              <Flex key={step.id} align="center">
                <Box w={6} h={6} borderRadius="full" bg={progress >= step.percentageToComplete ? 'green.500' : 'gray.300'} display="flex" alignItems="center" justifyContent="center">
                  {progress >= step.percentageToComplete && <Icon as={FaCheck} color="white" fontSize="xs" />}
                </Box>
                <Text ml={3} color={progress >= step.percentageToComplete ? 'gray.800' : 'gray.500'} className={`${(progress < step.percentageToComplete && steps[index > 0 ? index - 1 : 0].percentageToComplete <= progress) ? "blinking-text" : ""}`}>{step.name}</Text>
              </Flex>
            )
          })}
        </VStack>
      </Box>
    </Flex>
  );
};

